import {
  CLOSET_PATH,
  CLOSET_VALUE,
  FLOOR_PATH,
  FLOOR_VALUE,
  HANDING_PATH,
  HANDING_VALUE,
  LED_MIRRORS_PATH,
  LED_MIRRORS_VALUE,
  MIRROR_CABINETS_PATH,
  MIRROR_CABINETS_VALUE,
  MIRRORS_PATH,
  MIRRORS_VALUE,
  PEDESTAL_PATH,
  PEDESTAL_VALUE,
  UNDER_WASHING_MACHINE_PATH,
  UNDER_WASHING_MACHINE_VALUE
} from '@shared/constants/catalog';

export const CATEGORY_URL: Record<string, string> = {
  [PEDESTAL_VALUE]: PEDESTAL_PATH,
  [CLOSET_VALUE]: CLOSET_PATH,
  [MIRRORS_VALUE]: MIRRORS_PATH
};

export const SUB_CATEGORY_URL: Record<string, string> = {
  [HANDING_VALUE]: HANDING_PATH,
  [FLOOR_VALUE]: FLOOR_PATH,
  [UNDER_WASHING_MACHINE_VALUE]: UNDER_WASHING_MACHINE_PATH,
  [LED_MIRRORS_VALUE]: LED_MIRRORS_PATH,
  [MIRROR_CABINETS_VALUE]: MIRROR_CABINETS_PATH
};

export const CATEGORY_ATTRIBUTES: Record<string, string> = {
  [PEDESTAL_VALUE]: PEDESTAL_PATH,
  [CLOSET_VALUE]: CLOSET_PATH,
  [MIRRORS_VALUE]: MIRRORS_PATH
};
